import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'

const routes = [
    {
        path: '/',
        name: '主页',
        component: () => import('../layout/index.vue'),
        redirect: '/index',
        meta: {
            title: '主页'
        },
        children: [
            {
                path: '/index',
                name: '首页',
                component: () => import('../views/index/index'),
                componentName: 'index',
                meta: {title: '/index'}
            },
            {
                path: '/sys/user',
                name: '用户管理',
                component: () => import('../views/sys/user/user'),
                componentName: 'user',
                meta: {title: '/sys/user'}
            },
            {
                path: '/sys/role',
                name: '角色管理',
                component: () => import('../views/sys/role/role'),

                meta: {title: '/sys/role'}
            },
            {
                path: '/sys/menu',
                name: '菜单管理',
                component: () => import('../views/sys/menu/menu'),
                meta: {title: '/sys/menu'}
            },
            {
                path: '/bsns/department',
                name: '部门管理',
                component: () => import('../views/bsns/department'),
                meta: {title: '/bsns/department'}
            },
            {
                path: '/bsns/fish',
                name: '库存信息',
                component: () => import('../views/bsns/fish/fish'),
                meta: {title: '/bsns/fish'}
            },
            {
                path: '/bsns/fishinfomation',
                name: '能耗管理',
                component: () => import('../views/bsns/fish/fishinfomation'),
                meta: {title: '/bsns/fishinfomation'}
            },
            {
                path: '/bsns/addgoods',
                name: '添加鱼糜库存',
                component: () => import('../views/bsns/addgoods'),
                meta: {title: '/bsns/addgoods'}
            },
            {
                path: '/bsns/label',
                name: '产品名称',
                component: () => import('../views/bsns/fishLabel/label'),
                meta: {title: '/bsns/label'}
            },
            {
                path: '/bsns/Mixuse',
                name: '掺用鱼糜出库',
                component: () => import('../views/bsns/mixuse/Mixuse'),
                meta: {title: '/bsns/Mixuse'}
            },
            {
                path: '/bsns/testList',
                name: '计划出库',
                component: () => import('../views/bsns/testlist/testList'),
                meta: {title: '/bsns/testList'}
            },
            {
                path: '/bsns/Goods',
                name: '出库明细',
                component: () => import('../views/bsns/Goods'),
                meta: {title: '/bsns/Goods'}
            },
            {
                path: '/bsns/Monitor',
                name: '出库表单',
                component: () => import('../views/bsns/log_mix/Monitor'),
                meta: {title: '/bsns/Monitor'}
            },
            {
                path: '/bsns/addtest',
                name: '添加生产通知单',
                component: () => import('../views/bsns/testlist/components/addtest'),
                meta: {title: '/bsns/addtest'}
            },
            {
                path: '/bsns/customer',
                name: '客户名单',
                component: () => import('../views/bsns/customer/customer'),
                meta: {title: '/bsns/customer'}
            },
            {
                path: '/bsns/printLabel',
                name: '打印标签',
                component: () => import('../views/bsns/printLabel2.vue'),
                meta: {title: '/bsns/printLabel'}
            },
            {
                path: '/userCenter',
                name: '个人中心',
                component: () => import('../views/userCenter/userCenter'),
                meta: {title: '/userCenter'}
            },

            {
                path: '/demo1',
                name: 'demo',
                component: () => import('../views/bsns/fish/fishDeplay.vue'),
                meta: {title: '/demo'}
            },
            {
                path: '/bsns/Mix',
                name: '浆料管理',
                component: () => import('../views/bsns/mix/Mix'),
                meta: {title: '/bsns/Mix'}
            },
            {
                path: '/purFish/addmix',
                name: '添加外购鱼糜',
                component: () => import('../views/mix/mixadd'),
                meta: {title: '/purFish/addmix'}
            },
            {
                path: '/bsns/createReport',
                name: '制作产品日报表',
                component: () => import('../views/bsns/createReport'),
                meta: {title: '/bsns/createReport'}
            },
            {
                path: '/probins/storage',
                name: '配料库存信息',
                component: () => import('../views/probins/storage/storage.vue'),
                meta: {title: '/probins/storage'}
            },
            {
                path: '/probins/out',
                name: '配料出库',
                component: () => import('../views/probins/out/out.vue'),
                meta: {title: '/probins/out'}
            },
            {
                path: '/probins/compute',
                name: '配方计算',
                component: () => import('../views/probins/compute/compute.vue'),
                meta: {title: '/probins/out'}
            },
            {
                path: '/probins/formulaUsage',
                name: '配方使用记录',
                component: () => import('../views/probins/formulaUsage/formulaUsage.vue'),
                meta: {title: '/probins/formulaUsage'}
            },
            {
                path: '/buy/record',
                name: '收购记录',
                component: () => import('../views/buy/record.vue'),
                meta: {title: '/buy/record'}
            },
            {
                path: '/buy/semi',
                name: '半成品记录',
                component: () => import('../views/semi/semi.vue'),
                meta: {title: '/buy/semi'}
            },
            {
                path: '/buy/price',
                name: '价格管理',
                component: () => import('../views/buy/price.vue'),
                meta: {title: '/buy/price'}
            },
            {
                path: '/storage/display',
                name: '冷库方位',
                componentName: 'display',
                component: () => import('../views/storage/display/display.vue'),
                meta: {title: '/storage/display'}
            },
            {
                path: '/proteins/tableByDay',
                name: '日记表',
                componentName: 'tableByDay',
                component: () => import('../views/proteins/tableByDay.vue'),
                meta: {title: '/proteins/tableByDay'}
            },
            {
                path: '/dataAnalysis/productByunit',
                name: '单位产品分析',
                componentName: 'productByunit',
                component: () => import('../views/dataAnalysis/productByunit.vue'),
                meta: {title: '/dataAnalysis/productByunit'}
            },
            {
                path: '/dataAnalysis/total',
                name: '成本统计',
                componentName: 'total',
                component: () => import('../views/dataAnalysis/total.vue'),
                meta: {title: '/dataAnalysis/total'}
            },
            {
                path: '/dataAnalysis/fixedAssets',
                name: '固定资产分析',
                componentName: 'fixedAssets',
                component: () => import('../views/dataAnalysis/fixedAssets.vue'),
                meta: {title: '/dataAnalysis/fixedAssets'}
            },
            {
                path: '/dataAnalysis/productAnalysis',
                name: '产品分析',
                componentName: 'productAnalysis',
                component: () => import('../views/dataAnalysis/productAnalysis.vue'),
                meta: {title: '/dataAnalysis/productAnalysis'}
            },
            {
                path: '/dataAnalysis/customer',
                name: '客户分析',
                componentName: 'customer',
                component: () => import('../views/dataAnalysis/customer.vue'),
                meta: {title: '/dataAnalysis/customer'}
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login'),
        meta: {title: '/login'}
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('../views/404.vue'),
        meta: {title: '页面未找到'}
    }
];


const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach((to, from, next) => {

    // 根据 to.name 或 to.path 更新 editableTabsValue
    if (to.name !== 'login') {
        console.log('Navigating to:', to);
        const tabInfo = {
            name: to.name,
            path: to.path
        };
        if (to.name !== '404') {
            store.commit('ADD_TABS', tabInfo);
        }
    }

    // 确保菜单项也能正确选中
    store.commit('SET_ACTIVE_TAB', to.path);
    next();
});

export default router
